import React, { FC, useContext } from 'react'
import Link from 'next/link'

import css from './ReadMore.module.scss'
import { ArticleContext } from '../../../contexts/articleContext'
import JournalItem from '../JournalItem/JournalItem'
import ArrowIcon from '../../../public/static/icons/arrow-brown.svg'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'

const ReadMore: FC = () => {
  const { more } = useContext(ArticleContext)

  return (
    <section className={css.readMore}>
      <MaxWidth className={css.readMore_inner}>
        <p className={css.readMore_heading}>
          <span className={css.heading_text}>Продолжить читать</span>
          <Link href={`/journal`} passHref>
            <a className={css.heading_link}>
              Все статьи <ArrowIcon />
            </a>
          </Link>
        </p>
        <ul className={css.readMore_posts}>
          {more?.map((item) => {
            return <JournalItem key={item.id} post={item} size="small" />
          })}
        </ul>
      </MaxWidth>
    </section>
  )
}

export default ReadMore
